// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3Z5Xr","rootSuccess":"CompleteLink_rootSuccess__JWWFW","rootFailure":"CompleteLink_rootFailure__3nZOA","isDisabled":"CompleteLink_isDisabled__1gLHG"};